import { render } from "./ProformaDetalle.vue?vue&type=template&id=32a4c796&scoped=true"
import script from "./ProformaDetalle.vue?vue&type=script&lang=js"
export * from "./ProformaDetalle.vue?vue&type=script&lang=js"

import "./ProformaDetalle.vue?vue&type=style&index=0&id=32a4c796&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a4c796"]])

export default __exports__